<template src="./Romaneio.html"></template>

<script>
import appApi from '../../plugins/api'
import ConfirmModal from '../../components/ConfirmModal'
import ImageModal from '../../components/romaneio/ImageModal'
import AcabamentoChart from '../../components/romaneio/AcabementoChart'
import AuxChart from '../../components/romaneio/AuxChart'
import CardAux from '../../components/romaneio/CardAux'
import Relatorio from '../../components/romaneio/Relatorio'
import CardDistribuicao from '../../components/romaneio/CardDistribuicao'
import DispersaoChart from '../../components/romaneio/DispersaoChart'
import Feedbacks from '../../components/feedback/FeedbackList'
import RomaneioExample from './romaneioExample'

export default {
  components: {
    'app-confirm-modal': ConfirmModal,
    'doughnut-chart': AcabamentoChart,
    'aux-chart': AuxChart,
    'card-aux': CardAux,
    'card-dist': CardDistribuicao,
    'dispersao-chart': DispersaoChart,
    'image-modal': ImageModal,
    Feedbacks: Feedbacks,
    relatorio: Relatorio
  },
  props: ['showPdf', 'trackId'],
  data: function () {
    return {
      weigth_purchase: false,
      showCommentDialog: false,
      search: '',
      openImage: false,
      animal: '',
      romaneio: null,
      load: true,
      graphAcabemnto: null,
      graphMaturidade: null,
      graphFaixaPesos: null,
      graphConformacao: null,
      graphDistMarket: null,
      graphDistCategoria: null,
      graphDistRaca: null,
      graphDispersaoPesoVivo: null,
      graphDispersaoPesoCarcaca: null,
      pesosIntervalosVivo: null,
      pesosIntervalosCarcaca: null,
      approveRomaneio: null,
      showAlert: false,
      snackbar: {},
      tabledata: [],
      headers: [
        {
          text: 'Seq',
          value: 'nr_sequencial_ind',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Sisbov',
          value: 'st_sisbov',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Chip',
          value: 'st_chip',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Raça',
          value: 'breed_name',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Categoria',
          value: 'category_name',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'PV',
          value: 'peso_vivo',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'P1+P2',
          value: 'total_carcaca',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Rendimento',
          value: 'rendimento',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Destino Abate',
          value: 'destiny_name',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Motivo',
          value: 'motivo',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Contusão',
          value: 'flags',
          sortable: false,
          class: ['animals-head']
        },
        {
          text: 'Acabamento',
          value: 'finish_name',
          sortable: true,
          class: ['animals-head']
        },
        {
          text: 'Fotos',
          value: 'actions',
          sortable: false,
          class: ['animals-head']
        }
      ],
      currencyFormatter: null,

      totais: {
        acabamento: null,
        maturidade: null,
        peso: null,
        conformacao: null,
        dif: null
      },
      infosGerais: {
        racaPredominante: null,
        categoria: null
      },
      pagination: { rowsPerPage: -1 },
      auxs: [],
      dialogQrCode: false
    }
  },

  computed: {},

  mounted: function () {
    window.scrollTo(0, 0)
    if (this.$route.params.id && !this.showPdf) {
      appApi.getRomaneioAuxs().then((result) => {
        this.auxs = result.data
        this.getRomaneio(this.$route.params.id)
      })
    } else {
      this.load = false
    }

    this.currencyFormatter = new Intl.NumberFormat([], {
      style: 'currency',
      currency: 'BRL'
    })
  },

  methods: {
    holdPageBottom() {
      // Technical adjust to prevent page to scroll up when opening modal for the first time
      // setTimeout(() => {
      //  window.scrollTo(0,document.body.scrollHeight);
      // }, 0)

      document.getElementById('feedbacklist').scrollIntoView()
    },

    showDialog() {
      // Superior button
      this.showCommentDialog = !this.showCommentDialog
    },

    startRomaneio(track_id) {
      appApi.getRomaneioAuxs().then((result) => {
        this.auxs = result.data
        this.getRomaneio(track_id)
        setTimeout(() => {
          this.$refs.relatorioPage.startDownload(track_id)
        }, 1000)
      })
    },

    finishDownload() {
      this.$emit('finish-download')
    },

    getRomaneio: function (id) {
      if (id === 'exemplo') {
        this.romaneio = RomaneioExample
        this.calcAnimals()
        this.calcGraphAcabamento()
        this.calcgraphMaturidade()
        this.calcGraphFaixaPesos()
        this.calcGraphConformacao()
        this.calcGraphDistMarket()
        this.calcGraphDistCategoria()
        this.calcGraphDistRaca()
        this.calcGraphDispersaoChart('peso_vivo')
        this.calcGraphDispersaoChart('total_carcaca')
        this.calcGraphIntervaloPeso()
        this.getTableData()
        this.load = false
        return
      }

      appApi
        .getRomaneio(id)
        .then((result) => {
          this.romaneio = result.data
          this.weigth_purchase =
            this.romaneio.flags && this.romaneio.flags.weigth_purchase
              ? true
              : false
          this.removeHeaders()
          this.calcAnimals()
          this.calcGraphAcabamento()
          this.calcgraphMaturidade()
          this.calcGraphFaixaPesos()
          this.calcGraphConformacao()
          this.calcGraphDistMarket()
          this.calcGraphDistCategoria()
          this.calcGraphDistRaca()
          this.calcGraphDispersaoChart('peso_vivo')
          this.calcGraphDispersaoChart('total_carcaca')
          this.calcGraphIntervaloPeso()
          this.getTableData()
          this.getGeneralInfos()
          this.load = false
          this.showAlert = true
        })
        .catch((error) => {
          this.load = false
        })
    },

    removeHeaders() {
      if (this.weigth_purchase) {
        const h = [
          'peso_vivo',
          'total_carcaca',
          'rendimento',
          'flags',
          'finish_name'
        ]

        for (let key in h) {
          for (let i in this.headers) {
            if (h[key] == this.headers[i].value) {
              delete this.headers[i]
              break
            }
          }
        }
      }
    },

    calcAnimals: function () {
      try {
        let acabamento = {
          indesejavel: { total: 0, percent: 0 },
          toleravel: { total: 0, percent: 0 },
          desejavel: { total: 0, percent: 0 }
        }

        let totalContusoes = 0
        let totalInconsistencias = 0

        for (let i = 0; i < this.romaneio.animals.length; i++) {
          let animal = this.romaneio.animals[i]
          animal.flag_inconsistencia = animal.flag_inconsistencia
            ? animal.flag_inconsistencia
            : 'N'
          if (animal.flag_inconsistencia.toLowerCase().trim() === 's') {
            this.romaneio.flag_inconsistencia = true
            totalInconsistencias++
          }

          animal.flag_contusao = animal.flag_contusao
            ? animal.flag_contusao
            : 'N'
          if (animal.flag_contusao.toLowerCase().trim() === 's') {
            totalContusoes++
          }

          //indesejavel : (100 / result.totalAnimais) * indesejavel
          if (animal.acabamento_id == '1' || animal.acabamento_id == '5') {
            acabamento.indesejavel.total++
            acabamento.indesejavel.percent = (
              (100 / this.romaneio.qtde_cab) *
              acabamento.indesejavel.total
            ).toFixed(0)
          }
          if (animal.acabamento_id == '4') {
            acabamento.toleravel.total++
            acabamento.toleravel.percent = (
              (100 / this.romaneio.qtde_cab) *
              acabamento.toleravel.total
            ).toFixed(0)
          }
          if (animal.acabamento_id == '3' || animal.acabamento_id == '2') {
            acabamento.desejavel.total++
            acabamento.desejavel.percent = (
              (100 / this.romaneio.qtde_cab) *
              acabamento.desejavel.total
            ).toFixed(0)
          }
        }
        this.romaneio.classificacao_lote =
          this.calcClassificacaoLote(acabamento)
        this.romaneio.acabamento = acabamento
        this.romaneio.total_contusoes = totalContusoes
        this.romaneio.porcentagem_contusoes = (
          (100 / parseInt(this.romaneio.qtde_cab)) *
          totalContusoes
        ).toFixed(2)
      } catch (error) {
        console.log(error)
      }
    },

    calcClassificacaoLote(acabamentoStats) {
      //bom
      if (acabamentoStats.desejavel.percent >= 50) {
        return 0
      }
      //medio
      else if (
        acabamentoStats.desejavel.percent < 50 &&
        acabamentoStats.indesejavel.percent < 25
      ) {
        return 1
      }
      //ruim
      else {
        return 2
      }
    },

    calcGraphIntervaloPeso: function () {
      try {
        let intervalo = Math.floor(Math.sqrt(this.romaneio.qtde_cab))

        let refLinesMaxVivo = 0
        let refLinesMaxCarcaca = 0
        let refLinesMinVivo = parseFloat(this.romaneio.animals[0].peso_vivo)
        let refLinesMinCarcaca = parseFloat(
          this.romaneio.animals[0].total_carcaca
        )

        for (let i = 0; i < this.romaneio.animals.length; i++) {
          let animal = this.romaneio.animals[i]
          if (animal.peso_vivo > refLinesMaxVivo) {
            refLinesMaxVivo = animal.peso_vivo
          }
          if (animal.total_carcaca > refLinesMaxCarcaca) {
            refLinesMaxCarcaca = animal.total_carcaca
          }

          if (animal.peso_vivo < refLinesMinVivo) {
            refLinesMinVivo = animal.peso_vivo
          }
          if (animal.total_carcaca < refLinesMinCarcaca) {
            refLinesMinCarcaca = animal.total_carcaca
          }
        }

        let difVivo = Math.ceil(refLinesMaxVivo - refLinesMinVivo)
        let difCarcaca = Math.ceil(refLinesMaxCarcaca - refLinesMinCarcaca)

        let intervaloVivo = Math.ceil(difVivo / intervalo)
        let intervaloCarcaca = Math.ceil(difCarcaca / intervalo)

        let pesosIntervalosVivo = []
        let pesosIntervalosCarcaca = []

        for (let i = 0; i < intervalo; i++) {
          let ini = Math.round(
            parseFloat(refLinesMinVivo) + i * parseFloat(intervaloVivo)
          )
          let fim = Math.round(
            parseFloat(refLinesMinVivo) + (i + 1) * parseFloat(intervaloVivo)
          )
          pesosIntervalosVivo[i] = {
            name: '[' + ini + '-' + fim + ']',
            ini: ini,
            fim: fim,
            value: 0
          }

          let ini_carcaca = Math.round(
            parseFloat(refLinesMinCarcaca) + i * parseFloat(intervaloCarcaca)
          )
          let fim_carcaca = Math.round(
            parseFloat(refLinesMinCarcaca) +
              (i + 1) * parseFloat(intervaloCarcaca)
          )
          pesosIntervalosCarcaca[i] = {
            name: '[' + ini_carcaca + '-' + fim_carcaca + ']',
            ini: ini_carcaca,
            fim: fim_carcaca,
            value: 0
          }
        }

        for (let i = 0; i < this.romaneio.animals.length; i++) {
          let animal = this.romaneio.animals[i]
          let pesoVivo = Math.round(animal.peso_vivo ? animal.peso_vivo : 0)
          let pesoFinal = Math.round(parseFloat(animal.total_carcaca))

          for (let i = 0; i < pesosIntervalosVivo.length; i++) {
            if (
              pesoVivo >= pesosIntervalosVivo[i].ini &&
              pesoVivo < pesosIntervalosVivo[i].fim
            ) {
              pesosIntervalosVivo[i].value++
            }
          }
          if (
            pesoVivo === pesosIntervalosVivo[pesosIntervalosVivo.length - 1].fim
          ) {
            pesosIntervalosVivo[pesosIntervalosVivo.length - 1].value++
          }

          for (let i = 0; i < pesosIntervalosCarcaca.length; i++) {
            if (
              pesoFinal >= pesosIntervalosCarcaca[i].ini &&
              pesoFinal < pesosIntervalosCarcaca[i].fim
            ) {
              pesosIntervalosCarcaca[i].value++
            }
          }
          if (
            pesoFinal ===
            pesosIntervalosCarcaca[pesosIntervalosCarcaca.length - 1].fim
          ) {
            pesosIntervalosCarcaca[pesosIntervalosCarcaca.length - 1].value++
          }
        }

        this.pesosIntervalosVivo = pesosIntervalosVivo
        this.pesosIntervalosCarcaca = pesosIntervalosCarcaca
      } catch (error) {
        console.log('error', error)
      }
    },

    calcGraphDispersaoChart: function (type) {
      let mediapeso =
        type === 'peso_vivo' ? 'media_peso_vivo' : 'media_peso_carcaca'
      let totalDispPesosVivo = {
        series: [],
        referenceLine: {
          value: this.romaneio[mediapeso]
            ? parseFloat(this.romaneio[mediapeso]).toFixed(2)
            : 0,
          name: 'Média'
        },
        desvioPadrao: 0
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        let animal = this.romaneio.animals[i]

        totalDispPesosVivo.series.push({
          name: animal.nr_sequencial_ind.toString(),
          value: animal[type] ? animal[type] : 0,
          label:
            'Peso: ' +
            (animal[type] ? animal[type] : 0) +
            '\n Nr Sequencial: ' +
            animal.nr_sequencial_ind.toString(),
          data: [
            {
              x: animal.nr_sequencial_ind,
              y: animal[type] ? animal[type] : 0,
              r: 5
            }
          ],
          backgroundColor: '#2196F3',
          hoverBackgroundColor: '#3F51B5'
        })
      }

      let desvioPadrao = 0.0

      totalDispPesosVivo.series.forEach((element) => {
        let pow = Math.pow(
          parseFloat(element.value) -
            parseFloat(totalDispPesosVivo.referenceLine.value),
          2
        )
        desvioPadrao += pow
      })
      totalDispPesosVivo.desvioPadrao = parseFloat(
        Math.sqrt(desvioPadrao / totalDispPesosVivo.series.length)
      ).toFixed(2)

      if (type === 'peso_vivo') {
        this.graphDispersaoPesoVivo = totalDispPesosVivo
      } else {
        this.graphDispersaoPesoCarcaca = totalDispPesosVivo
      }
    },

    calcGraphDistCategoria: function () {
      let graphDistCategoria = {}
      for (let key in this.auxs['category']) {
        graphDistCategoria[key + ''] = {
          name: this.auxs['category'][key],
          total: 0,
          percentage: 0
        }
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        if (graphDistCategoria[animal.categoria_id + '']) {
          graphDistCategoria[animal.categoria_id + ''].total += 1
          graphDistCategoria[animal.categoria_id + ''].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            graphDistCategoria[animal.categoria_id + ''].total
          ).toFixed(2)
        }
      }

      let totalCategoria = 0
      let categoria = ''

      for (let item in graphDistCategoria) {
        if (totalCategoria < graphDistCategoria[item + ''].total) {
          totalCategoria = graphDistCategoria[item + ''].total
          categoria = graphDistCategoria[item + ''].name
        }
      }

      this.infosGerais.categoria = categoria

      this.graphDistCategoria = graphDistCategoria
    },

    calcGraphDistRaca: function () {
      let graphDistRaca = {}
      for (let key in this.auxs['breed']) {
        graphDistRaca[key + ''] = {
          name: this.auxs['breed'][key],
          total: 0,
          percentage: 0
        }
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        if (graphDistRaca[animal.raca_id + '']) {
          graphDistRaca[animal.raca_id + ''].total += 1
          graphDistRaca[animal.raca_id + ''].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            graphDistRaca[animal.raca_id + ''].total
          ).toFixed(2)
        }
      }

      let deleteValues = []

      for (let key in graphDistRaca) {
        if (graphDistRaca[key].total == 0) {
          deleteValues.push(key)
        }
      }

      for (let i = 0; i < deleteValues.length; i++) {
        delete graphDistRaca[deleteValues[i]]
      }

      let totalRaca = 0
      let raca = ''

      for (let item in graphDistRaca) {
        if (totalRaca < graphDistRaca[item + ''].total) {
          totalRaca = graphDistRaca[item + ''].total
          raca = graphDistRaca[item + ''].name
        }
      }

      this.infosGerais.racaPredominante = raca

      this.graphDistRaca = graphDistRaca
    },

    calcGraphDistMarket: function () {
      let graphDistMarket = {}
      for (let key in this.auxs['market']) {
        graphDistMarket[key + ''] = {
          name: this.auxs['market'][key],
          total: 0,
          percentage: 0
        }
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        if (graphDistMarket[animal.mercado_id + '']) {
          graphDistMarket[animal.mercado_id + ''].total += 1
          graphDistMarket[animal.mercado_id + ''].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            graphDistMarket[animal.mercado_id + ''].total
          ).toFixed(2)
        }
      }
      this.graphDistMarket = graphDistMarket
    },

    calcGraphAcabamento: function () {
      let finish = this.auxs['finish']
      let graphAcabemnto = {}
      let totalAcabamento = 0

      for (let key in finish) {
        graphAcabemnto[key] = { name: finish[key], total: 0, percentage: 0 }
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        if (graphAcabemnto[animal.acabamento_id + '']) {
          graphAcabemnto[animal.acabamento_id + ''].total += 1
          graphAcabemnto[animal.acabamento_id + ''].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            graphAcabemnto[animal.acabamento_id + ''].total
          ).toFixed(2)
        }
      }

      for (let key in finish) {
        totalAcabamento += graphAcabemnto[key].total
      }

      this.totais.acabamento = totalAcabamento
      this.graphAcabemnto = graphAcabemnto
    },

    calcgraphMaturidade: function () {
      let graphMaturidade = {}
      let totalMaturidade = 0

      for (let key in this.auxs['maturity']) {
        graphMaturidade[key + ''] = {
          name: this.auxs['maturity'][key],
          total: 0,
          percentage: 0,
          totalGeral: 0
        }
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        if (graphMaturidade[animal.maturidade_id + '']) {
          graphMaturidade[animal.maturidade_id + ''].total += 1
          graphMaturidade[animal.maturidade_id + ''].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            graphMaturidade[animal.maturidade_id + ''].total
          ).toFixed(2)
        }
      }
      this.graphMaturidade = graphMaturidade
    },

    calcGraphFaixaPesos: function () {
      let pesos = [
        { name: 'Menor 15@', total: 0, percentage: 0 },
        { name: '15 a 16@', total: 0, percentage: 0 },
        { name: '16 a 18@', total: 0, percentage: 0 },
        { name: '18 a 22@', total: 0, percentage: 0 },
        { name: 'Maior 22@', total: 0, percentage: 0 },
        { name: 'N/A', total: 0, percentage: 0 }
      ]
      let totalPeso = 0

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        const totalPesoArroba = animal.total_carcaca / 15
        if (totalPesoArroba <= 15) {
          pesos[0].total++
          this.totais.peso += pesos[0].total
          pesos[0].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            pesos[0].total
          ).toFixed(2)
        } else if (totalPesoArroba > 15 && totalPesoArroba <= 16) {
          pesos[1].total++
          this.totais.peso += pesos[0].total
          pesos[1].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            pesos[1].total
          ).toFixed(2)
        } else if (totalPesoArroba > 16 && totalPesoArroba <= 18) {
          pesos[2].total++
          this.totais.peso += pesos[0].total
          pesos[2].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            pesos[2].total
          ).toFixed(2)
        } else if (totalPesoArroba > 18 && totalPesoArroba <= 22) {
          pesos[3].total++
          this.totais.peso += pesos[0].total
          pesos[3].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            pesos[3].total
          ).toFixed(2)
        } else if (totalPesoArroba > 22) {
          pesos[4].total++
          this.totais.peso += pesos[0].total
          pesos[4].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            pesos[4].total
          ).toFixed(2)
        }
      }

      for (let i = 0; i < pesos.length; i++) {
        totalPeso += pesos[i].total
      }

      this.totais.peso = totalPeso
      this.graphFaixaPesos = pesos
    },

    calcGraphConformacao: function () {
      let graphConformacao = {}
      let totalConformacao = 0

      for (let key in this.auxs['conformation']) {
        graphConformacao[key + ''] = {
          name: this.auxs['conformation'][key],
          total: 0,
          percentage: 0
        }
      }

      for (let i = 0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i]
        if (graphConformacao[animal.conformacao_id + '']) {
          graphConformacao[animal.conformacao_id + ''].total += 1
          graphConformacao[animal.conformacao_id + ''].percentage = (
            (100 / parseInt(this.romaneio.qtde_cab)) *
            graphConformacao[animal.conformacao_id + ''].total
          ).toFixed(2)
        }
      }

      for (let key in this.auxs['conformation']) {
        totalConformacao += graphConformacao[key + ''].total
      }

      this.totais.conformacao = totalConformacao
      this.graphConformacao = graphConformacao
    },

    getTableData() {
      let data = []
      this.romaneio.animals.forEach((animal) => {
        this.tabledata.push({
          animal: animal,
          nr_sequencial_ind: animal.nr_sequencial_ind,
          st_sisbov: animal.st_sisbov,
          st_chip: animal.st_chip,
          breed_name:
            this.romaneio.industria.sif_sie !==
              (Number('0941') || Number('941')) &&
            this.auxs['breed'][animal.raca_id]
              ? this.auxs['breed'][animal.raca_id]
              : '',
          category_name: this.auxs['category'][animal.categoria_id]
            ? this.auxs['category'][animal.categoria_id]
            : '',
          peso_vivo: !isNaN(parseFloat(animal.peso_vivo))
            ? parseFloat(animal.peso_vivo).toFixed(0) + ' Kg'
            : 0,
          peso_final_carcaca_1: animal.peso_final_carcaca_1,
          peso_final_carcaca_2: animal.peso_final_carcaca_2,
          total_carcaca: animal.total_carcaca + ' Kg',
          rendimento: animal.rendimento + '%',
          finish_name: this.auxs['finish'][animal.acabamento_id]
            ? this.auxs['finish'][animal.acabamento_id]
            : '',
          conformation_name: this.auxs['conformation'][animal.conformacao_id]
            ? this.auxs['conformation'][animal.conformacao_id]
            : '',
          maturity_name: this.auxs['maturity'][animal.maturidade_id]
            ? this.auxs['maturity'][animal.maturidade_id]
            : '',
          destiny_name: this.auxs['destiny'][animal.destino_id]
            ? this.auxs['destiny'][animal.destino_id]
            : '',
          _flags: {
            flag_contusao: animal.flag_contusao,
            flag_inconsistencia: animal.flag_inconsistencia
          },
          flags: animal.flags,
          actions: '',
          motivo: animal.motivo
        })
      })
    },

    showPicture(animal) {
      this.animal = null
      appApi
        .getRomaneioImages(animal.track_id, animal.nr_sequencial_ind)
        .then((result) => {
          this.animal = animal
          this.animal.weigth_purchase = this.weigth_purchase
          try {
            this.animal['image'] = result.data[0][0]
          } catch (error) {}
          this.openImage = true
        })
    },

    getUrlTrack() {
      let props = this.$router.resolve({
        name: 'Track',
        query: { track_id: this.romaneio.track_id }
      })

      return process.env.VUE_APP_URL_TRACK
        ? process.env.VUE_APP_URL_TRACK + props.href
        : props.href
    },

    openTrackPage() {
      let url = this.getUrlTrack()
      window.open(url, '_system', '')
    },

    getGeneralInfos() {
      let totalDIF = 0

      for (let index in this.tabledata) {
        if (this.tabledata[index].destiny_name == 'DIF') {
          totalDIF++
        }
      }
      this.totais.dif = totalDIF
    },

    calculateNaoClassificada() {
      const { desejavel, toleravel, indesejavel } = this.romaneio.acabamento
      const desejavelPercent = desejavel ? Number(desejavel.percent) : 0
      const toleravelPercent = toleravel ? Number(toleravel.percent) : 0
      const indesejavelPercent = indesejavel ? Number(indesejavel.percent) : 0
      const naoClassificadaPercent =
        100 - (desejavelPercent + toleravelPercent + indesejavelPercent)
      return {
        percent: naoClassificadaPercent >= 0 ? naoClassificadaPercent : 0
      }
    }
  },

  computed: {
    changeTrackId() {
      this.trackId = this.$route.params.id
      return this.trackId
    }
  }
}
</script>
<style scoped lang="css">
#pageRomaneio {
  position: relative;
}
#pageRomaneio .btn-feedback {
  top: -38px;
  left: calc(100% - 150px);
}
#pageRomaneio .btn-add {
  position: fixed;
  top: 90px;
  left: calc(100% - 60px);
}
#pageRomaneio .card-romaneio {
  margin-bottom: 10px;
}

#pageRomaneio .romaneio-label {
  display: block;
}

#pageRomaneio .acabamento-graph {
  position: relative;
  max-height: 150px;
}

#pageRomaneio .aux-chart {
  margin-top: 10px;
  position: relative;
  height: 250px;
}

#pageRomaneio .animals-table table.v-table thead th {
  background-color: #455a64;
  color: #fff;
}

#pageRomaneio .theme--light.v-card .v-card__text {
  color: #212121;
}

.animals-table >>> .v-data-table-header.v-data-table-header-mobile {
  display: none !important;
}
.animals-table >>> tbody tr .v-data-table__mobile-row:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 960px) {
  #pageRomaneio
    >>> .animals-table.theme--light.v-data-table
    tbody
    tr
    td:first-child,
  #pageRomaneio
    >>> .animals-table.theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:last-child {
    border: 0px;
  }

  .animals-table >>> tbody tr {
    border: 1px solid #e4e4e4;
    display: block;
    margin-bottom: 10px;
    border-radius: 4px;
    padding-bottom: 10px;
    overflow: hidden;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }
}
</style>
